import request from "@/utils/request";

export async function fileUpload() {
  return (await request({
    url: `/oss/file-upload-auth-sts`,
    method: 'GET'
  })).data;
}
export async function getTemplateUrl(url) {
  return (await request({
    url,
    method: "get",
  })).data;
}

export async function analyzeFile(url, data) {
  return (await request({
    url,
    method: 'post',
    data
  })).data;
}
export async function analyzeResult(url, data) {
  return (await request({
    url,
    method: 'post',
    data
  })).data;
}
export async function submitFile(url, data) {
  return (await request({
    url,
    method: 'post',
    data
  })).data;
}
